/**
 * Whether the signed-in user must enroll MFA before continuing.
 * Facility-card accounts are exempt via the Auth custom claim only.
 *
 * @param {{
 *   user: unknown,
 *   isEnrolled: boolean,
 *   skipUi?: boolean,
 *   claims?: Record<string, unknown> | null,
 * }} params
 * @returns {boolean}
 */
export function needsMfaEnrollment({ user, isEnrolled, skipUi, claims } = {}) {
  if (claims?.facilityCard === true) return false;
  return !!user && !isEnrolled && !skipUi;
}

/**
 * True when the ID token carries the facility access card claim.
 * @param {Record<string, unknown> | null | undefined} claims
 * @returns {boolean}
 */
export function hasFacilityCardClaim(claims) {
  return claims?.facilityCard === true;
}
